export enum PoolPositions {
  None,
  Staked,
  Challenged,
}
